<template>
    <div>
    <b-card-group deck>
        <b-card header="Datos Personales" header-bg-variant="dark" header-tag="header" header-text-variant="white">
        <b-row class="mb-2">
            <b-col sm="1" class="text-sm-left"><b>Id: </b>{{ this.personal.Id }}</b-col>
            <b-col sm="6" class="text-sm-left"><b>Apellido y Nombre: </b>{{ this.personal.DisplayName }}</b-col>
            <b-col sm="3" class="text-sm-left"><b>Edad: </b>{{ this.personal.DisplayEdad }}</b-col>
            <b-col sm="2" class="text-sm-left"><b>Cuil: </b>{{ this.personal.DisplayCuil }}</b-col>
        </b-row>
        </b-card>
    </b-card-group>
    </div>
</template>

<script>
export default {
    name: 'CardDatosPersonales',
    props: {
        personal: Object,
    }
}
</script>




// WEBPACK FOOTER //
// src/components/common/CardDatosPersonales.vue